import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Container } from '../../assets/styles/GlobalStyle'
import { RootState, useAppSelector } from '../../store'
import { AuthState } from '../../store/authSlice'
//
import en from 'date-fns/locale/en-US'
import ka from 'date-fns/locale/ka'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
//
// @ts-ignore
import dayjs from 'dayjs'
import { Form, Formik, useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import CheckmarkIcon from '../../assets/icons/JSX/CheckmarkIcon'
import CircleCheckmarkIcon from '../../assets/icons/JSX/CircleCheckmarkIcon'
import CircleCloseRedIcon from '../../assets/icons/JSX/CircleCloseRedIcon'
import FemaleIcon from '../../assets/icons/JSX/FemaleIcon'
import MaleIcon from '../../assets/icons/JSX/MaleIcon'
import Colors from '../../assets/styles/Colors'
import Button from '../../components/Button'
import Input from '../../components/Input'
import Loader from '../../components/Loader'
import ScreenHeader from '../../components/ScreenHeader'
import Dropdown from '../../components/v2/Dropdown'
import PhoneNumberInput from '../../components/v2/PhoneNumberInput'
import { AppState } from '../../store/appSlice'
//
//
const Profile = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  // countries array from apი
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const currentUserBirthDay = auth?.user?.birthday ? new Date(auth?.user?.birthday) : null
  //
  const userAge = dayjs(new Date()).diff(dayjs(auth?.user?.birthday), 'year')
  //
  const [sendEmailVerificationLinkState, setsendEmailVerificationLinkState] = useState(true)
  //
  const [email, setEmail] = useState(auth.user?.email || '')
  //
  const [phone, setPhone] = useState(auth.user?.phone || '')
  //
  const [age, setAge] = useState(userAge || '')
  //
  const [firstNameEn, setFirstNameEn] = useState(auth.user?.firstName || '')
  //
  const [lastNameEn, setLastNameEn] = useState(auth.user?.lastName || '')
  //
  const [firstNameGe, setFirstNameGe] = useState(auth.user?.firstNameGe || '')
  //
  const [lastNameGe, setlastNameGe] = useState(auth.user?.lastNameGe || '')
  //
  const [citizenship, setCitizenship] = useState(auth.user?.citizenship || '')
  //
  const [personalNumber, setPersonalNumber] = useState(auth.user?.personalNumber || '')
  //
  const [passportNumber, setPassportNumber] = useState(auth.user?.passportNumber || '')
  //
  const [gender, setGender] = useState(auth.user?.gender || '')
  // ! as never for date picker !!!
  const [birthday, setBirthday] = useState<Date | null | undefined>(currentUserBirthDay || null)
  //
  //
  //
  const navigate = useNavigate()
  //
  const [disableForm, setDisableForm] = useState(false)
  //
  const {
    data: emailVerificationRequestResponse,
    error: emailVerificationRequestError,
    isLoading: isEmailVerificationLoading,
  } = api.useSendEmailVerificationLinkQuery(undefined, { skip: sendEmailVerificationLinkState })
  // ############################################
  // update profile mutation
  const [updateProfile, { isLoading: updateProfileLoading }] = api.useUpdateProfileMutation()
  // ############################################
  //
  const updateProfileInfo = async () => {
    // e.preventDefault();
    try {
      await updateProfile({
        firstNameEn: firstNameEn,
        lastNameEn: lastNameEn,
        firstNameGe: firstNameGe,
        lastNameGe: lastNameGe,
        citizenship: citizenship,
        personalNumber: personalNumber,
        passportNumber: passportNumber,
        gender: gender,
        birthday: dayjs(birthday).format('YYYY-MM-DD'),
        phone: phone,
        email: email,
      }).unwrap()
      setDisableForm(true)
      navigate('/my-policies')
      toast.success(`${t('profileIsUpdated')}`)
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error(`${t('anErrorOccurred')}`)
      }
    }
  }
  //
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  // georgian letter regex
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  // yup validations schema
  const PersonalInfoValidationSchema = Yup.object({
    firstNameEn: Yup.string()
      .min(2, `${t('minNameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    lastNameEn: Yup.string()
      .min(2, `${t('minNameLetterLenght')}`)
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .matches(englishLetterRegex, `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
    firstNameGe: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship === 'GE',
      then: Yup.string()
        .min(2, `${t('minNameLetterLenght')}`)
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .matches(georgianLetterRegex, `${t('onlyGeorgianLetters')}`)
        .required(`${t('required')}`),
      otherwise: Yup.string().notRequired(),
    }),
    lastNameGe: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship === 'GE',
      then: Yup.string()
        .min(2, `${t('minNameLetterLenght')}`)
        .matches(georgianLetterRegex, `${t('onlyGeorgianLetters')}`)
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .required(`${t('required')}`),
      otherwise: Yup.string().notRequired(),
    }),

    personalNumber: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship === 'GE',
      then: Yup.string()
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .matches(/^[a-zA-Z0-9]*$/, ` `)
        .min(11, `${t('personalNumberValidation')}`)
        .max(11, `${t('personalNumberValidation')}`)
        .required(`${t('required')}`),
      otherwise: Yup.string()
        .matches(/^[0-9]+$/, ` `)
        .notRequired(),
    }),
    gender: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .required(`${t('required')}`),
    citizenship: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .required(`${t('required')}`),
    passportNumber: Yup.string().when('citizenship', {
      is: (citizenship: string) => citizenship !== 'GE',
      then: Yup.string()
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .matches(/^[a-zA-Z0-9]*$/, ` `)
        // .max(9, `${t('passportNumberValidation')}`)
        .required(`${t('required')}`),
      otherwise: Yup.string()
        .matches(/^\S*$/, `${t('spaceValidation')}`)
        .matches(/^[a-zA-Z0-9]*$/, ` `)
        .max(9, `${t('passportNumberValidation')}`),
    }),
    birthday: Yup.string().required(`${t('required')}`),
    phone: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      // .min(9, `${t('enterValidPhone')}`)
      // .max(9, `${t('enterValidPhone')}`)
      .required(`${t('required')}`),
    email: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .email('გთხოვთ შეიყვანოთ ვალიდური მეილი')
      .required(`${t('required')}`),
  })
  // initial values
  const initialValues = {
    phone: phone || '',
    email: email || '',
    age: age || '',
    firstNameEn: firstNameEn || '',
    lastNameEn: lastNameEn || '',
    firstNameGe: firstNameGe || '',
    lastNameGe: lastNameGe || '',
    citizenship: citizenship || '',
    personalNumber: personalNumber || '',
    passportNumber: passportNumber || '',
    gender: gender || '',
    birthday: birthday || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: PersonalInfoValidationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(false)
    },
  })
  //
  //
  useEffect(() => {
    if (emailVerificationRequestResponse) {
      toast.success(emailVerificationRequestResponse.message, { toastId: emailVerificationRequestResponse.message })
    }
    //
    if (emailVerificationRequestError) {
      // @ts-ignore
      toast.error(emailVerificationRequestError?.data?.message, {
        // @ts-ignore
        toastId: emailVerificationRequestError?.data?.message,
      })
    }
  }, [emailVerificationRequestResponse, emailVerificationRequestError])
  //
  //
  const handleNextButtonClick = (setTouched: any) => {
    setTouched({
      phone: true,
      email: true,
      age: true,
      firstNameEn: true,
      lastNameEn: true,
      firstNameGe: true,
      lastNameGe: true,
      citizenship: true,
      personalNumber: true,
      passportNumber: true,
      gender: true,
      birthday: true,
    })

    formik.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        updateProfileInfo()
      }
    })
  }
  //
  //
  const MainLoading = updateProfileLoading || isEmailVerificationLoading || isCountriesLoading
  //
  //
  return MainLoading ? (
    <Loader />
  ) : auth.user ? (
    <Formik
      initialValues={initialValues}
      validationSchema={PersonalInfoValidationSchema}
      enableReinitialize={true}
      validateOnMount={true}
      validateOnChange={true}
      validateOnBlur={true}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false)
      }}
    >
      {({ handleSubmit, handleBlur, setFieldValue, touched, errors, setTouched }) => (
        <Form onSubmit={handleSubmit}>
          <Section>
            <ScreenHeader text={t('myDashboard')} url="/my-policies" />
            <Container>
              <MainWrapper>
                <LargeTitle>{t('updateProfile')}</LargeTitle>

                <Wrapper>
                  <CustomForm>
                    <PhoneNumberInput
                      style={{ marginBottom: '24px' }}
                      hideButtons={true}
                      id="phone"
                      label={`${t('phone')}`}
                      value={phone}
                      onChange={(value) => [setPhone(value), setFieldValue('phone', value)]}
                      error={(touched.phone || phone) && errors.phone ? true : false}
                      errorText={errors.phone}
                      onBlur={handleBlur}
                    />

                    <EmailInputBox>
                      <Input
                        id="email"
                        label={t('email')}
                        type="text"
                        placeholder=""
                        value={email}
                        name="email"
                        onChange={(value) => [setEmail(value), setFieldValue('email', value)]}
                        error={(touched.email || email) && errors.email ? true : false}
                        errorText={errors.email}
                        onBlur={handleBlur}
                        width={'fullWidth'}
                        style={{ marginBottom: '24px' }}
                      />

                      {auth && auth.user && auth.user.emailVerification === false ? (
                        <EmailVerificationBox>
                          {t('clickToVerify')}{' '}
                          <CircleCloseRedIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => setsendEmailVerificationLinkState(false)}
                          />
                        </EmailVerificationBox>
                      ) : (
                        <EmailVerificationBox>
                          <CircleCheckmarkIcon />
                        </EmailVerificationBox>
                      )}
                    </EmailInputBox>

                    <DatePicketWrapper>
                      <DatePickerLabel>{t('dateOfBirth')}</DatePickerLabel>
                      <DatePicker
                        disabled={auth?.user?.sgsVerification === true ? true : false}
                        maxDate={new Date()}
                        selected={birthday || null}
                        onChange={(date) => {
                          setBirthday(date)
                          handleSubmit()
                        }}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText=""
                        locale={lang === 'ge' ? ka : en}
                        onFocus={(e) => e.target.blur()}
                        dateFormat="dd/MM/yyyy"
                      />
                    </DatePicketWrapper>

                    <Input
                      id="age"
                      label={t('age')}
                      type="number"
                      placeholder=""
                      value={age}
                      name="age"
                      onChange={(value) => [setAge(value), setFieldValue('age', value)]}
                      width={'fullWidth'}
                      style={{ marginBottom: '24px' }}
                      disabled={true}
                    />

                    {countries && (
                      <Dropdown
                        style={{
                          userSelect: auth?.user?.sgsVerification === true ? 'none' : 'unset',
                          pointerEvents: auth?.user?.sgsVerification === true ? 'none' : 'unset',
                          marginBottom: '24px',
                        }}
                        title={`${t('cityzenship')}`}
                        isSearchable={true}
                        isDisabled={auth?.user?.sgsVerification === true ? true : false}
                        value={countries.find((x) => x.isoCode === citizenship)?.isoCode}
                        options={[
                          ...countries.map((item: any) => ({
                            value: item.isoCode,
                            label: item.translations?.[lang]?.name,
                          })),
                        ]}
                        onChange={(event) => setCitizenship(event.value)}
                        error={(touched.citizenship || citizenship) && errors.citizenship ? true : false}
                        errorText={errors.citizenship}
                      />
                    )}

                    {citizenship === 'GE' ? (
                      <Input
                        id="georgian-name"
                        name="georgian-name"
                        label={t('nameInGeorgia')}
                        type="text"
                        placeholder=""
                        disabled={auth?.user?.sgsVerification === true ? true : false}
                        value={firstNameGe}
                        onChange={(value) => [setFirstNameGe(value), setFieldValue('firstNameGe', value)]}
                        error={(touched.firstNameGe || firstNameGe) && errors.firstNameGe ? true : false}
                        errorText={errors.firstNameGe}
                        onBlur={handleBlur}
                        width={'fullWidth'}
                        style={{ marginBottom: '24px' }}
                      />
                    ) : null}

                    {citizenship === 'GE' ? (
                      <Input
                        id="georgian-last-name"
                        name="georgian-last-name"
                        label={t('surnameInGeorgia')}
                        type="text"
                        placeholder=""
                        disabled={auth?.user?.sgsVerification === true ? true : false}
                        value={lastNameGe}
                        onChange={(value) => [setlastNameGe(value), setFieldValue('lastNameGe', value)]}
                        error={(touched.lastNameGe || lastNameGe) && errors.lastNameGe ? true : false}
                        errorText={errors.lastNameGe}
                        onBlur={handleBlur}
                        width={'fullWidth'}
                        style={{ marginBottom: '24px' }}
                      />
                    ) : null}

                    <Input
                      id="english-fist-name"
                      name="english-fist-name"
                      label={t('nameInEnglish')}
                      type="text"
                      placeholder=""
                      value={firstNameEn}
                      onChange={(value) => [setFirstNameEn(value), setFieldValue('firstNameEn', value)]}
                      error={(touched.firstNameEn || firstNameEn) && errors.firstNameEn ? true : false}
                      errorText={errors.firstNameEn}
                      onBlur={handleBlur}
                      width={'fullWidth'}
                      style={{ marginBottom: '24px' }}
                    />

                    <Input
                      id="english-last-name"
                      name="english-last-name"
                      label={t('surnameInEnglish')}
                      type="text"
                      placeholder=""
                      value={lastNameEn}
                      onChange={(value) => [setLastNameEn(value), setFieldValue('lastNameEn', value)]}
                      error={(touched.lastNameEn || lastNameEn) && errors.lastNameEn ? true : false}
                      errorText={errors.lastNameEn}
                      onBlur={handleBlur}
                      width={'fullWidth'}
                      style={{ marginBottom: '24px' }}
                    />

                    <Input
                      id="personal-number"
                      name="personal-number"
                      label={t('personalNumber')}
                      disabled={auth?.user?.sgsVerification === true ? true : false}
                      type="text"
                      placeholder=""
                      value={personalNumber}
                      onChange={(value) => [setPersonalNumber(value), setFieldValue('personalNumber', value)]}
                      error={(touched.personalNumber || personalNumber) && errors.personalNumber ? true : false}
                      errorText={errors.personalNumber}
                      onBlur={handleBlur}
                      width={'fullWidth'}
                      style={{ marginBottom: '24px' }}
                    />

                    <Input
                      id="passport-number"
                      name="passport-number"
                      label={t('passportNumber')}
                      type="text"
                      placeholder=""
                      value={passportNumber}
                      onChange={(value) => [setPassportNumber(value), setFieldValue('passportNumber', value)]}
                      error={(touched.passportNumber || passportNumber) && errors.passportNumber ? true : false}
                      errorText={errors.passportNumber}
                      onBlur={handleBlur}
                      width={'fullWidth'}
                      style={{ marginBottom: '24px' }}
                    />

                    <ChooseGenderLabel>{t('chooseGender')}</ChooseGenderLabel>
                    <ChooseGender
                      style={{
                        userSelect: auth?.user?.sgsVerification === true ? 'none' : 'unset',
                        pointerEvents: auth?.user?.sgsVerification === true ? 'none' : 'unset',
                      }}
                    >
                      <ChooseGenderWrapper
                        onClick={() => [setGender('female'), setFieldValue('gender', 'female')]}
                        style={{
                          borderColor: gender === 'female' ? Colors.primaryBlack : Colors.secondaryGrey,
                        }}
                      >
                        {gender === 'female' ? (
                          <CheckmarkIconBox>
                            <CheckmarkIcon />
                          </CheckmarkIconBox>
                        ) : null}
                        <ChooseGenderContent>
                          <FemaleIcon />
                          <span>{t('female')}</span>
                        </ChooseGenderContent>
                      </ChooseGenderWrapper>
                      {/*  */}
                      <ChooseGenderWrapper
                        onClick={() => [setGender('male'), setFieldValue('gender', 'male')]}
                        style={{
                          borderColor: gender === 'male' ? Colors.primaryBlack : Colors.secondaryGrey,
                        }}
                      >
                        {gender === 'male' ? (
                          <CheckmarkIconBox>
                            <CheckmarkIcon />
                          </CheckmarkIconBox>
                        ) : null}
                        <ChooseGenderContent>
                          <MaleIcon />
                          <span>{t('male')}</span>
                        </ChooseGenderContent>
                      </ChooseGenderWrapper>
                    </ChooseGender>

                    <br />
                    <br />
                    <Button
                      onClick={() => handleNextButtonClick(setTouched)}
                      text={t('saveChanges')}
                      btnStyleType="primary"
                      fullWidth={true}
                      disabled={disableForm}
                    />
                  </CustomForm>
                </Wrapper>
              </MainWrapper>
            </Container>
          </Section>
        </Form>
      )}
    </Formik>
  ) : null
}

// styles
const ChooseGenderLabel = styled.label`
  font-size: 14px;
  margin-bottom: 10px;
  color: ${Colors.primaryGrey};
`
const ChooseGender = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const ChooseGenderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    margin-top: 18px;
    font-size: 14px;
    color: ${Colors.primaryBlack};
  }
`
const CheckmarkIconBox = styled.div`
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 1;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${Colors.primaryRed};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Colors.white};
  svg {
    width: 12px;
    height: fit-content;
  }
`
const ChooseGenderWrapper = styled.div`
  border: 1px solid ${Colors.primaryBlack};
  width: 180px;
  height: 120px;
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;

  ${Responsive.mobile} {
    max-width: 180px;
    width: 100%;
    min-width: 120px;

    &:first-of-type {
      margin-right: 20px;
    }
  }
`
const Section = styled.div`
  padding-bottom: 10px;
`
const EmailVerificationBox = styled.div`
  height: 20px;
  position: absolute;
  top: 3px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: ${Colors.primaryRed};
  svg {
    height: inherit;
    width: 20px;
    margin-left: 5px;
  }
`
const EmailInputBox = styled.div`
  position: relative;
  margin-bottom: 24px;
`
const Wrapper = styled.div`
  background-color: ${Colors.white};
  padding: 48px 64px 56px 64px;
  max-width: 528px;
  margin: 0 auto 140px auto;

  /* responsive */
  ${Responsive.mobile} {
    padding: 32px 24px 40px 24px;
    margin-bottom: 100px;
  }
`
const CustomForm = styled.div`
  margin-bottom: 25px;
`
const MainWrapper = styled.div`
  /*  */
`
const LargeTitle = styled.h1`
  font-size: 36px;
  line-height: 40px;
  color: ${Colors.primaryBlack};
  text-align: center;
  margin-top: 56px;
  margin-bottom: 56px;
  text-transform: capitalize;

  /* responsive */
  ${Responsive.tablet} {
    font-size: 24px;
    line-height: 26px;
  }

  /* responsive */
  ${Responsive.mobile} {
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 56px;
    margin-top: 56px;
  }
`
//
// date picker custom styles
const DatePickerLabel = styled.div`
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 12px;
  text-align: left;
  padding-right: 24px;
  color: ${Colors.primaryGrey};
  margin-right: auto;
`
const DatePicketWrapper = styled.div`
  //react-datepicker
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 528px;
  margin: 0 auto;
  margin-bottom: 24px;
  /*  */
  .react-datepicker {
    font-family: inherit;
  }
  /*  */
  .react-datepicker__header__dropdown.react-datepicker__header__dropdown--select {
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      width: 45%;
      margin-block: 10px;
      select {
        width: 100%;
        height: 30px;
        border-radius: 4px;
        border: unset;
        outline: 1px solid ${Colors.primaryBlack};
        background-color: ${Colors.white};
        color: ${Colors.primaryBlack};
        font-weight: 600;
      }
    }
  }
  /* styles with className */
  .react-datepicker-wrapper {
    width: 100%;
    /* visibility: hidden; */
  }
  .react-datepicker__input-container {
    input {
      width: 100%;
      outline: none;
      border: 1px solid ${Colors.secondaryGrey};
      border-radius: 4px;
      height: 57px;
      padding: 18px 22px;
      color: ${Colors.primaryBlack};
    }
  }
  .react-datepicker-ignore-onclickoutside {
    width: 100%;
  }
  .react-datepicker__triangle {
    display: none;
  }
  .react-datepicker__navigation--previous {
    left: -12px;
  }
  .react-datepicker__navigation--next {
    right: -12px;
  }
  .react-datepicker-popper {
    padding: 30px 35px;
    background-color: ${Colors.white};
    -webkit-box-shadow: 0px 0px 15px 3px #88888811;
    box-shadow: 0px 0px 15px 3px #88888811;
    border-radius: 8px;
    z-index: 4;
    ${Responsive.tablet} {
      padding: 30px 35px;
    }
    ${Responsive.mobile} {
      padding: 20px 12.5px 25px 12.5px;
      position: absolute;
      top: 1024px !important;
      left: 50% !important;
      transform: translate(-50%, -500px) !important;
    }
  }
  .react-datepicker__current-month {
    font-size: 18px;
    color: ${Colors.primaryBlack};
    font-weight: 500;
    line-height: 9px;
    margin-bottom: 20px;
  }
  .react-datepicker {
    border: 0px;
  }
  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-left-radius: 8px;
  }
  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-right-radius: 8px;
  }
  .react-datepicker__header {
    background-color: ${Colors.white};
    border-bottom: 0px;
  }
  .react-datepicker__day--selected {
    background-color: ${Colors.primaryRed} !important;
    color: ${Colors.white} !important;
    outline: none;
  }
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    width: 40px;
    /* height: 46px; */
    border-radius: 50% !important;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-weight: normal;
    color: ${Colors.primaryGrey};

    ${Responsive.mobile} {
      width: 35px;
      line-height: 35px;
      font-size: 13px;
    }
  }
  .react-datepicker__day--selected:hover {
    background-color: ${Colors.primaryRed} !important;
    border-radius: 50% !important;
    font-size: 14px;
  }
  .react-datepicker__day:hover {
    background-color: ${Colors.primaryRed} !important;
    border-radius: 50% !important;
    color: ${Colors.white};
    font-size: 14px;
  }
  .react-datepicker__day--in-range {
    background-color: ${Colors.secondaryGrey};
    color: ${Colors.primaryBlack};
    border-radius: 0px;
  }
  .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ) {
    background-color: ${Colors.secondaryGrey};
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background-color: transparent;
  }
  /* disable days */
  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    user-select: none;
    pointer-events: none;
    opacity: 0.3;
  }
`
export default Profile
